import { Typography, TextField, Modal, Box, Button } from "@mui/material";
import { IContact } from "../../../types/CommonTypes";
import { formatedDateTime } from "../../../commons/constants/helpers";

const ContactView = ({
	contact,
	isOpen,
	onClose,
}: {
	contact?: IContact;
	isOpen: boolean;
	onClose: () => void;
}) => {
	return (
		<Modal open={isOpen} onClose={onClose}>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: 500,
					bgcolor: "background.paper",
					p: 3,
				}}
			>
				<Typography variant="h6">{contact?.name}</Typography>
				<Typography
					variant="subtitle2"
					color="text.secondary"
					sx={{ mb: 1 }}
				>
					{formatedDateTime(contact?.date)}
				</Typography>
				<Typography variant="subtitle1">
					{contact?.phoneNumber}
				</Typography>
				<Typography variant="subtitle1">{contact?.city}</Typography>
				<TextField
					multiline
					rows={10}
					variant="outlined"
					label="Message"
					value={contact?.message}
					fullWidth
					InputProps={{
						readOnly: true,
					}}
					sx={{ mt: 2 }}
				/>
				<Button
					style={{ marginTop: "10px" }}
					variant="contained"
					fullWidth
					onClick={onClose}
				>
					Cerrar
				</Button>
			</Box>
		</Modal>
	);
};

export default ContactView;
